import classNames from 'classnames';

import type { FC } from 'react';

interface SpinnerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'size-6',
  md: 'size-10',
  lg: 'size-14',
};

export const Spinner: FC<SpinnerProps> = ({ className, size = 'md' }) => (
  <div
    className={classNames(
      'animate-spin rounded-full border-2 border-[#0788f1]/20 border-t-[#0788f1]',
      sizeClasses[size],
      className,
    )}
    role="status"
    aria-label="Загрузка"
  />
);
